<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="emergencyBadges.data" [active]="emergencyBadges.active"
                    [valueSelected]="emergencyBadges.valueSelected"
                    (selectAnswer)="onEmergencyBadgesSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <div class="default-text large" [innerHTML]="textCopy.contraventionsTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.contraventionsText"></div>
    <contraventions-question [valuesSelected]="contraventionsQuestion.valuesSelected"
                             [options]="contraventionsQuestion.options"
                             (selectAnswer)="onContraventionsQuestionSelected($event)"
                             [active]="contraventionsQuestion.active"></contraventions-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <radio-question [data]="reconsider.data" [active]="emergencyBadges.valueSelected === '0'"
                    [valueSelected]="reconsider.valueSelected"
                    (selectAnswer)="onReconsiderSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <select-question [data]="cancellation.data" [active]="reconsider.valueSelected !== 'n'"
                     [valueSelected]="cancellation.valueSelected"
                     (selectAnswer)="onCancellationSelected($event)"></select-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
